function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { componentCls } from "../../components/style/wave";
import { cn } from "../utils";
import CSSMotion from 'rc-motion';
import { render, unmount } from 'rc-util/lib/React/render';
import raf from 'rc-util/lib/raf';
import * as React from 'react';
import { TARGET_CLS } from "./type";
import { validateNum } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
var WaveEffect = function WaveEffect(props) {
  var className = props.className,
    target = props.target,
    component = props.component;
  var divRef = React.useRef(null);

  // const [color, setWaveColor] = React.useState<string | null>(null);
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    borderRadius = _React$useState2[0],
    setBorderRadius = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    left = _React$useState4[0],
    setLeft = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    top = _React$useState6[0],
    setTop = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    width = _React$useState8[0],
    setWidth = _React$useState8[1];
  var _React$useState9 = React.useState(0),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    height = _React$useState10[0],
    setHeight = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    enabled = _React$useState12[0],
    setEnabled = _React$useState12[1];
  var waveStyle = {
    left: left,
    top: top,
    width: width,
    height: height,
    borderRadius: borderRadius.map(function (radius) {
      return "".concat(radius, "px");
    }).join(' ')
  };

  // long 和 short 单独设置
  if (target.classList.contains('ring-btn-green')) {
    waveStyle['--wave-color'] = 'var(--bds-green-100-bg)';
  } else if (target.classList.contains('ring-btn-red')) {
    waveStyle['--wave-color'] = 'var(--bds-red-100-bg)';
  } else {
    // 指定统一的 wave 颜色
    waveStyle['--wave-color'] = 'var(--bds-brand-100-bg)';
  }
  function syncPos() {
    var nodeStyle = getComputedStyle(target);

    // Get wave color from target
    // setWaveColor(getTargetWaveColor(target));

    var isStatic = nodeStyle.position === 'static';

    // Rect
    var borderLeftWidth = nodeStyle.borderLeftWidth,
      borderTopWidth = nodeStyle.borderTopWidth;
    setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
    setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
    setWidth(target.offsetWidth);
    setHeight(target.offsetHeight);

    // Get border radius
    var borderTopLeftRadius = nodeStyle.borderTopLeftRadius,
      borderTopRightRadius = nodeStyle.borderTopRightRadius,
      borderBottomLeftRadius = nodeStyle.borderBottomLeftRadius,
      borderBottomRightRadius = nodeStyle.borderBottomRightRadius;
    setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map(function (radius) {
      return validateNum(parseFloat(radius));
    }));
  }
  React.useEffect(function () {
    if (target) {
      // We need delay to check position here
      // since UI may change after click
      var id = raf(function () {
        syncPos();
        setEnabled(true);
      });

      // Add resize observer to follow size
      var resizeObserver;
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(syncPos);
        resizeObserver.observe(target);
      }
      return function () {
        var _resizeObserver;
        raf.cancel(id);
        (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 ? void 0 : _resizeObserver.disconnect();
      };
    }
  }, []);
  if (!enabled) {
    return null;
  }
  var isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains(TARGET_CLS));
  return /*#__PURE__*/_jsx(CSSMotion, {
    visible: true,
    motionAppear: true,
    motionName: componentCls,
    motionDeadline: 500,
    onAppearEnd: function onAppearEnd(_, event) {
      if (event.deadline || event.propertyName === 'opacity') {
        var _divRef$current;
        var holder = (_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.parentElement;
        if (holder) {
          unmount(holder).then(function () {
            holder === null || holder === void 0 ? void 0 : holder.remove();
          });
        }
      }
      return false;
    },
    children: function children(_ref) {
      var motionClassName = _ref.className;
      return /*#__PURE__*/_jsx("div", {
        ref: divRef,
        className: cn(className, {
          'wave-quick': isSmallComponent
        }, motionClassName),
        style: waveStyle
      });
    }
  });
};
var showWaveEffect = function showWaveEffect(target, info) {
  var _target$querySelector;
  var component = info.component;

  // Skip for unchecked checkbox
  if (component === 'Checkbox' && !((_target$querySelector = target.querySelector('input')) !== null && _target$querySelector !== void 0 && _target$querySelector.checked)) {
    return;
  }

  // Create holder
  var holder = document.createElement('div');
  holder.style.position = 'absolute';
  holder.style.left = '0px';
  holder.style.top = '0px';
  target === null || target === void 0 ? void 0 : target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
  render( /*#__PURE__*/_jsx(WaveEffect, _objectSpread(_objectSpread({}, info), {}, {
    target: target
  })), holder);
};
export default showWaveEffect;